import { Component, inject } from '@angular/core';

import {
  AgGridComponent,
  AgGridEditabledComponent,
  CamGridDataService,
  FieldsSelectionComponent,
  GridControlComponent,
  GridCursorComponent,
  GridExpandableComponent,
  GridHighlightFilterComponent,
  GridMetaData,
  GridTagComponent,
  PaginationComponent,
  ParameterType,
} from '@camelot/core';

import { TestIdDirective } from '@camelot/testing-harness';

interface GridRow {
  budget: number;
  id: string;
  name: string;
  status: string;
}

const GRID_ROWS: GridRow[] = [
  { budget: 1200, id: '1', name: 'Alpha', status: 'Open' },
  { budget: 3400, id: '2', name: 'Beta', status: 'Closed' },
];

@Component({
    imports: [
        AgGridComponent,
        AgGridEditabledComponent,
        FieldsSelectionComponent,
        GridControlComponent,
        GridCursorComponent,
        GridExpandableComponent,
        GridHighlightFilterComponent,
        GridTagComponent,
        PaginationComponent,
        TestIdDirective,
    ],
    template: `
    <cam-grid-control camTestId="cam-grid-control" [gridId]="this.gridId" />
    <cam-grid-tag camTestId="cam-grid-tag" [gridId]="this.gridId" />
    <cam-grid-expandable camTestId="cam-grid-expandable" [gridId]="this.gridId" />
    <cam-grid-highlight-filter camTestId="cam-grid-highlight-filter" [gridId]="this.gridId" />
    <cam-fields-selection camTestId="cam-fields-selection" [gridId]="this.gridId" />
    <cam-grid-cursor camTestId="cam-grid-cursor" [gridId]="this.gridId" [navigation]="this.navigation" />
    <cam-ag-grid
      camTestId="cam-ag-grid"
      [gridId]="this.gridId"
      [colsMetaData]="this.colsMetaData"
      [data]="this.rows"
      defaultDisplay="grid"
    />
    <cam-grid-pagination camTestId="cam-grid-pagination" [gridId]="this.gridId" />
    <cam-ag-grid-editabled
      camTestId="cam-ag-grid-editabled"
      [gridId]="this.editableGridId"
      [colsMetaData]="this.colsMetaData"
    />
  `
})
export class CoreGridCase {
  public colsMetaData: GridMetaData[] = [
    { name: 'name', shownByDefault: true, type: ParameterType.String },
    { name: 'status', shownByDefault: true, type: ParameterType.String },
    { name: 'budget', shownByDefault: true, type: ParameterType.Currency },
  ];
  public editableGridId = 'e2e-grid-editable';
  public gridId = 'e2e-grid';
  public rows = GRID_ROWS;

  private readonly _dataService = inject(CamGridDataService);

  ngOnInit(): void {
    [this.gridId, this.editableGridId].forEach(id => {
      this._dataService.get(id, true).switchView('grid');
    });
  }

  public navigation = (): void => void 0;
}
